import React from "react";
import MaintenanceTypesActions from "./MaintenanceTypesActions";
import MaintenanceTypesGrid from "./MaintenanceTypesGrid";

function MaintenanceTypes() {
  return (
    <div>
      <MaintenanceTypesActions />
      <div className="uk-padding-small uk-background-default uk-border-rounded">
        <MaintenanceTypesGrid />
      </div>
    </div>
  );
}

export default MaintenanceTypes;
